export default "__VITE_ASSET__FvhAStol__"